import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-code-html-preview',
    templateUrl: './code-html-preview.component.html',
    styleUrls: ['./code-html-preview.component.less'],
})
export class CodeHtmlPreviewComponent implements OnInit {
    @Input() language?: string;

    code: string = '';

    editorOptions = { theme: 'vs-light', language: 'html' };

    constructor() {}

    ngOnInit(): void {
        this.editorOptions.language = this.language || 'html';
    }
}
